import { useAppDispatch } from '../../../../store';

export const useAdminConversationSendForm = () => {
    const dispatch = useAppDispatch();
    return {};
};
